import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <RankingSection />

        <IndexSection />

        <AboutSection />

        <MediaSection />

        <CarouselSection />

        <TopicsSection />

        <CommentsSection />

        <ContactSection />

        <CardsSection />

        <FaqSection />

        <FeaturesSection />

        <UpdatesSection />

        <AppSection />
      </main>

      <Footer />
    </div>
  );
}